import React from 'react'
import clsx from 'clsx'
import debounce from 'debounce'
import { useWindowSize, useWindowScroll } from 'react-use'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

const ScrollDown = () => {
  const [visible, setVisible] = React.useState(false)
  const { height: windowHeight } = useWindowSize()
  const { y: scrollY } = useWindowScroll()

  const handleScroll = debounce(() => {
    // add "72" to account for the footer height
    setVisible(scrollY === 0 && document.body.clientHeight > windowHeight + 72)
  }, 100)

  React.useEffect(() => {
    handleScroll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollY, document.body.clientHeight])

  return (
    <div
      className={clsx(
        'transition-transform fixed bottom-20 left-0 right-0 flex justify-center max-w-xl pb-4 mx-auto z-30',
        !visible && 'translate-y-40'
      )}
    >
      <Button
        color="blue"
        className="!rounded-full !shadow-lg space-x-1"
        onClick={() => {
          window.scrollTo({
            top: windowHeight,
            behavior: 'smooth',
          })
        }}
      >
        <Icon color="inverse">arrow_downward</Icon>
        <span>Geser ke bawah</span>
      </Button>
    </div>
  )
}

export default ScrollDown
